<div class="modal-header">
  <h5 class="modal-title text-center ml-auto mr-auto">Select Mastery</h5>
  <button (click)="modalService.closeOutletModals('public')" type="button" class="close" data-dismiss="modal" aria-label="Close">
    <svg-selector [svgName]="'close-small'" [svgColor]="'#ffffff'"></svg-selector>
  </button>
</div>
<div class="modal-body">
  <div class="row">
    <div class="col-md text-center" *ngIf="min < 1 && max >= 0">
      <img height="140" src="{{'https://cdn.ggboost.com/images/masteries/0.png' | cdn}}" alt="">
      <div class="rank-select-item" (click)="onSelect(0)" *ngIf="min < 1 && max >= 0">Mastery 0</div>
    </div>

    <div class="col-md text-center" *ngIf="min < 2 && max >= 1">
      <img height="140" src="{{'https://cdn.ggboost.com/images/masteries/1.png' | cdn}}" alt="">
      <div class="rank-select-item" (click)="onSelect(1)" *ngIf="min < 2 && max >= 1">Mastery 1</div>
    </div>

    <div class="col-md text-center" *ngIf="min < 3 && max >= 2">
      <img height="140" src="{{'https://cdn.ggboost.com/images/masteries/2.png' | cdn}}" alt="">
      <div class="rank-select-item" (click)="onSelect(2)" *ngIf="min < 3 && max >= 2">Mastery 2</div>
    </div>

    <div class="col-md text-center" *ngIf="min < 4 && max >= 3">
      <img height="140" src="{{'https://cdn.ggboost.com/images/masteries/3.png' | cdn}}" alt="">
      <div class="rank-select-item" (click)="onSelect(3)" *ngIf="min < 4 && max >= 3">Mastery 3</div>
    </div>

    <div class="col-md text-center" *ngIf="min < 5 && max >= 4">
      <img height="140" src="{{'https://cdn.ggboost.com/images/masteries/4.png' | cdn}}" alt="">
      <div class="rank-select-item" (click)="onSelect(4)" *ngIf="min < 5 && max >= 4">Mastery 4</div>
    </div>

    <div class="col-md text-center" *ngIf="min < 6 && max >= 5">
      <img height="140" src="{{'https://cdn.ggboost.com/images/masteries/5.png' | cdn}}" alt="">
      <div class="rank-select-item" (click)="onSelect(5)" *ngIf="min < 6 && max >= 5">Mastery 5</div>
    </div>

    <div class="col-md text-center" *ngIf="min < 7 && max >= 6">
      <img height="140" src="{{'https://cdn.ggboost.com/images/masteries/7.png' | cdn}}" alt="">
      <div class="rank-select-item" (click)="onSelect(6)" *ngIf="min < 7 && max >= 6">Mastery 6</div>
    </div>

    <div class="col-md text-center" *ngIf="min < 8 && max >= 7">
      <img height="140" src="{{'https://cdn.ggboost.com/images/masteries/10.png' | cdn}}" alt="">
      <div class="rank-select-item" (click)="onSelect(7)" *ngIf="min < 8 && max >= 7">Mastery 7</div>
    </div>

    <div class="col-md text-center" *ngIf="min < 9 && max >= 8">
      <img height="140" src="{{'https://cdn.ggboost.com/images/masteries/10.png' | cdn}}" alt="">
      <div class="rank-select-item" (click)="onSelect(8)" *ngIf="min < 9 && max >= 8">Mastery 8</div>
    </div>

    <div class="col-md text-center" *ngIf="min < 10 && max >= 9">
      <img height="140" src="{{'https://cdn.ggboost.com/images/masteries/10.png' | cdn}}" alt="">
      <div class="rank-select-item" (click)="onSelect(9)" *ngIf="min < 10 && max >= 9">Mastery 9</div>
    </div>

    <div class="col-md text-center" *ngIf="min < 11 && max >= 10">
      <img height="140" src="{{'https://cdn.ggboost.com/images/masteries/10.png' | cdn}}" alt="">
      <div class="rank-select-item" (click)="onSelect(10)" *ngIf="min < 11 && max >= 10">Mastery 10</div>
    </div>
  </div>
</div>